/*
 * Copyright (c) 2025.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Pavel Bobylev <pavel.bobylev1988@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export interface ProductVersion {
  id: number;
  productId: number;
  versionNumber: number;
  versionData: any;
  isCurrent: boolean;
  createdBy?: number;
  createdAt: Date;
}
